import React from "react";
import { Button, Box, List, ListItem, ListItemText } from "@mui/material";
import Grid from "@mui/material/Grid2";
import paypay_logo from "../assets/img/paypay_horizontal.png";
import paypal_logo from "../assets/img/paypal_horizontal.png";
import Sentence from "./Sentence";

const PaymentForm = ({ paymentLinks, leader }) => {
  console.log(leader[0].travel_cost);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      // sx={{ backgroundColor: '#fbf9f3' }} // 背景色を設定
    >
      <Box
        sx={{
          padding: 4,
          display: "inline-block", // コンテンツに合わせて横幅を調整
          //   textAlign: 'center',
          margin: "0 auto", // 親Boxを中央寄せ
        }}
      >
        <Grid container spacing={3}>
          <Grid item size={{ xs: 12 }}>
            <Box
              sx={{
                padding: 0,
                width: "100%",
                textAlign: "center",
                borderRadius: 2,
              }}
            >
              {/* <Title size='1.4rem'>
                              ご祝儀の事前送金
                            </Title> */}
            </Box>

            <List sx={{ width: "100%", pt: 0 }}>
              <ListItem alignItems="flex-start" sx={{ p: 0 }}>
                {/* 米印 */}
                <Box sx={{ mr: 1, pt: 1 }}>
                  <Sentence>※</Sentence>
                </Box>
                <ListItemText
                  sx={{
                    pt: 1,
                    mt: 0,
                    "& .MuiTypography-root": {
                      fontFamily: "'KokuGothic', sans-serif", // フォントを明示的に指定
                    },
                  }}
                  primary="送金時にお名前を明記していただくようお願い申し上げます"
                />
              </ListItem>
              <ListItem alignItems="flex-start" sx={{ p: 0 }}>
                {/* 米印 */}
                <Box sx={{ mr: 1, pt: 1 }}>
                  <Sentence>※</Sentence>
                </Box>
                <ListItemText
                  sx={{
                    pt: 1,
                    mt: 0,
                    fontFamily: "'KokuGothic', sans-serif",
                    "& .MuiTypography-root": {
                      fontFamily: "'KokuGothic', sans-serif", // フォントを明示的に指定
                    },
                  }}
                  primary="ご祝儀は 通常通り当日お持ちいただくことも可能です"
                />
              </ListItem>

              {leader[0]?.travel_cost === "yes" && (
                <ListItem alignItems="flex-start" sx={{ p: 0 }}>
                  <Box sx={{ mr: 1, pt: 1 }}>
                    <Sentence>※</Sentence>
                  </Box>
                  <ListItemText
                    sx={{
                      pt: 1,
                      mt: 0,
                      "& .MuiTypography-root": {
                        fontFamily: "'KokuGothic', sans-serif",
                      },
                    }}
                    primary="名古屋駅からの交通費として一律おひとり一万円を当日お渡しさせていただきます"
                  />
                </ListItem>
              )}
            </List>
          </Grid>

          <Grid container item size={{ xs: 12 }} spacing={2} direction="column">
            {paymentLinks.map((link, index) => (
              <Grid item sx={12} key={index}>
                <Button
                  variant="outlined"
                  href={link.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  fullWidth
                  sx={{
                    textTransform: "none",
                    height: "50px", // 親要素に合わせてボタンの高さを揃える
                    display: "flex",
                    justifyContent: "center", // ボタン内のコンテンツを中央に配置
                    alignItems: "center", // ボタン内のコンテンツを縦方向に中央揃え
                    // backgroundColor: '#ffffff',
                  }}
                >
                  {link.app_name === "PayPay" ? (
                    <>
                      <img
                        src={paypay_logo}
                        alt="PayPay"
                        style={{
                          width: "90px",
                          display: "block", // 画像を中央に配置するための設定
                          marginLeft: "auto", // 画像を中央に配置するための設定
                          marginRight: "auto", // 画像を中央に配置するための設定
                        }}
                      />
                      {/* {link.app_name} */}
                    </>
                  ) : link.app_name === "PayPal" ? (
                    <>
                      <img
                        src={paypal_logo}
                        alt="PayPal"
                        style={{
                          width: "80px",
                          display: "block", // 画像を中央に配置するための設定
                          marginLeft: "auto", // 画像を中央に配置するための設定
                          marginRight: "auto", // 画像を中央に配置するための設定
                        }}
                      />
                      {/* {link.app_name} */}
                    </>
                  ) : (
                    link.app_name
                  )}
                </Button>
              </Grid>
            ))}
          </Grid>
        </Grid>

        <Box className="spacer-lg"></Box>
      </Box>
    </Box>
  );
};

export default PaymentForm;
